import { Suspense, memo, useEffect, useMemo } from 'react'
import { SymbolName } from 'types'
import { PerpInfoTabs } from './Tabs'
import { useAtom } from 'jotai'
import { PerpInfoTabTypes, perpInfoTabAtom } from './atoms'
import { usePerpSymbols } from 'store/perp/hooks'
import { contractInformationSymbolAtom } from '../Information/atom'
import { ContractInfoView } from './ContractInfo'
import { FundingRateView } from './FundingRate'
import { InsuranceFundView } from './InsuranceFund'
import Loading from 'components/Loading'
import { Stack } from '@mui/material'

export const PerpInfo = memo<{ symbolName: SymbolName }>(({ symbolName }) => {
  const [tab, setTab] = useAtom(perpInfoTabAtom)
  const symbols = usePerpSymbols()
  const symbol = useMemo(() => {
    return symbols.find((s) => s.name === symbolName)
  }, [symbolName, symbols])
  useEffect(() => {
    return () => setTab(0)
  }, [setTab])

  const [currentSymbol, setCurrentSymbol] = useAtom(
    contractInformationSymbolAtom,
  )

  useEffect(() => {
    if (symbolName) {
      setCurrentSymbol(symbolName)
    }
  }, [setCurrentSymbol, symbolName])

  return (
    <div>
      <PerpInfoTabs />

      <Suspense
        fallback={
          <Stack alignItems={'center'} p="64px 0">
            <Loading />
          </Stack>
        }
      >
        {tab === PerpInfoTabTypes.ContractInfo && <ContractInfoView />}
        {tab === PerpInfoTabTypes.FundingRate && <FundingRateView />}
        {tab === PerpInfoTabTypes.InsuranceFund && <InsuranceFundView />}
      </Suspense>
    </div>
  )
})
